import { createAction } from '@reduxjs/toolkit';

import {
  ADD_BONUS,
  ADD_COUPON,
  ADD_EXTRA,
  ADD_PARTNER_BONUS,
  CHECK_PRICE_REDUCTION_BY_CASHBACK,
  GO_TO_ORDER_PAGE,
  PAY_BY_DISCOUNT,
  REMOVE_EXTRA,
  SUBMIT_PACKAGE,
  TOGGLE_EXTRA,
  UPDATE_ORDER_FAIL,
  VALIDATE_MOSGORTOUR_CERTIFICATE,
  ADD_MOSGORTOUR_CERTIFICATE_DISCOUNT,
} from '../constants/order';

import type {
  SetMosgortourPrebuildDataPayload,
  ValidateMosgortourCertificatePayload,
} from '../order/types';

export {
  skipFlights as skipFlightsAction,
  selectFlight,
  setFlightInfo as setFlightInfoAction,
  prebuildOrder as prebuildOrderAction,
  prebuildOrderSuccess,
  prebuildOrderCompleteWithMindboxErrors,
  prebuildOrderFail,
  createOrder as createOrderAction,
  createOrderSuccess,
  createOrderFail,
  confirmOrder as confirmOrderAction,
  changeOrderComment as changeOrderCommentAction,
  stashUserPriceBeforePay as stashUserPriceBeforePayAction,
  orderProcessed as orderProcessedAction,
  finishOrder as finishOrderAction,
  updateOrder as updateOrderAction,
  updateOrderSuccess as updateOrderSuccessAction,
  setOrdersAmount as setOrdersAmountAction,
  setFirstOrderNumber as setFirstOrderNumberAction,
  switchOrder as switchOrderAction,
  setFirstOrderField as setFirstOrderFieldAction,
  addMosgortourCertificate as addMosgortourCertificateAction,
  deleteMosgortourCertificate as deleteMosgortourCertificateAction,
  updateMosgortourCertificate as updateMosgortourCertificateAction,
  checkMosgortourCertificateTourist as checkMosgortourCertificateTouristAction,
  uncheckMosgortourCertificateTourist as uncheckMosgortourCertificateTouristAction,
  updateMosgortourSnils as updateMosgortourSnilsAction,
  setMosgortourPrebuildData as setMosgortourPrebuildDataAction,
  setRedirectUrl as setRedirectUrlAction,
} from '../reducers/order';

// Extras actions:
export const addExtraAction = createAction<string | undefined>(ADD_EXTRA);
export const removeExtraAction = createAction<string | undefined>(REMOVE_EXTRA);
export const toggleExtraAction = createAction<{
  hashsum?: string;
  selected: boolean;
}>(TOGGLE_EXTRA);

// Order actions:
export const goToOrderPageAction = createAction(GO_TO_ORDER_PAGE);

// Update order actions:
export const updateOrderFailedAction = createAction(UPDATE_ORDER_FAIL);

// Package actions:
export const submitPackageAction = createAction(SUBMIT_PACKAGE);

// Sub payments:
export const addCouponAction = createAction<string | null | undefined>(
  ADD_COUPON,
);
export const addBonusAction = createAction<string | number | null | undefined>(
  ADD_BONUS,
);
export const payByDiscountAction = createAction(PAY_BY_DISCOUNT);
export const checkPriceReductionByCashbackAction = createAction(
  CHECK_PRICE_REDUCTION_BY_CASHBACK,
);

export const addPartnerBonusAction = createAction<{
  kind: 'alfa_miles';
  amount: number;
} | null>(ADD_PARTNER_BONUS);

// Mosgortour Actions:
export const validateMosgortourCertificateAction =
  createAction<ValidateMosgortourCertificatePayload>(
    VALIDATE_MOSGORTOUR_CERTIFICATE,
  );
export const addMosgortourCertificateDiscountAction =
  createAction<SetMosgortourPrebuildDataPayload>(
    ADD_MOSGORTOUR_CERTIFICATE_DISCOUNT,
  );
